<div class="sdds-header">
  <span class="scania-text-symbol"></span>

  @if (!showCompnayName) {
    <span id="application-name" class="uppercase application-name is-landing-page">{{ 'eys.title' | translate }}</span>
  }
  @if (showCompnayName) {
    <span id="application-name" class="uppercase application-name is-not-landing-page">{{ 'eys.title' | translate }}</span>
  }

  @if (showCompnayName) {
    <span id="customerCompany" class="company-name sdds-detail-01 uppercase">{{ companyName }}</span>
  }
  <span class="scania-symbol"></span>
</div>

@if (showCompnayName) {
  <div class="sdds-content sdds-background-grey-50">
    <app-main (newItemEvent)="addCompanyName($event)"></app-main>
  </div>
}